import Marquee from "react-fast-marquee";

const WORDS = ["ÉVÉNEMENTS", "SON", "AMBIANCE", "CLÉ EN MAIN", "DJ BOOTH TRAILER", "LASER SHOW"];

export default function MarqueeSection() {
  return (
    <section className="relative bg-[#050505] overflow-hidden border-y border-white/10 py-6 md:py-9" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((word, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-heading text-5xl sm:text-6xl md:text-8xl font-semibold uppercase tracking-tight mx-6 md:mx-10 ${
                i % 2 === 0 ? "text-stroke-white" : "text-[#E60000]"
              }`}
            >
              {word}
            </span>
            <span className="w-2.5 h-2.5 md:w-3 md:h-3 bg-[#E60000] rotate-45 shrink-0" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
